__webpack_public_path__ = '/build/';

require('./bootstrap');
require('./common');
const VeeValidate = require('vee-validate');
const roleDirective = require('./directives/role').default;
const securityMixin = require('./mixins/security').default;
const featureFlagMixin = require('./mixins/feature-flags').default;

Vue.use(Vuex);
Vue.use(VeeValidate, {
    errorBagName: 'vErrors'
});

Vue.filter('phone', function(phone) {
    return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

// Utils
Vue.component('currency-input', require('./components/utils/currency-input.vue').default);
Vue.component('date-picker', require('vue-datepicker'));
Vue.component('loan-amount-range', require('./components/adsets/loan-amount-range.vue').default);
Vue.component('product', require('./components/adsets/product.vue').default);
Vue.component('select2', require('./components/utils/select2.vue').default);
Vue.component('slider', require('./components/adsets/slider.vue').default);
Vue.component('sumo-select', require('./components/utils/sumo-select.vue').default);
Vue.component('loading', require('./components/utils/loading.vue').default);
Vue.component('toggle-input', require('./components/utils/toggle-input.vue').default);
Vue.component('br-switch', require('./components/utils/switch.vue').default);
Vue.component('br-select', require('./components/utils/br-select.vue').default);
Vue.component('editable-field', require('./components/utils/editable-field.vue').default);
Vue.component('modal', require('./components/utils/modal.vue').default);
Vue.component('login-idle', require('./components/utils/login-idle.vue').default);
Vue.component('date-range-picker', require('./components/utils/br-date-picker.vue').default);
Vue.component('info-tooltip', require('./components/utils/info-tooltip.vue').default);
Vue.component('br-table', require('./components/utils/br-table.vue').default);
Vue.component('file-upload', require('./components/utils/file-upload.vue').default);
Vue.component('post-lead-table', require('./components/utils/post-lead-table.vue').default);
Vue.component('pulse-status', require('./components/utils/pulse-status.vue').default);
Vue.component('bap-collapse', require('./components/utils/collapse.vue').default);
Vue.component('roll-transition', require('./components/utils/roll-transition.vue').default);
Vue.component('backdrop-loader', require('./components/utils/backdrop-loader.vue').default);
Vue.component('overlay', require('./components/utils/overlay.vue').default);

// Auth
Vue.component('session-handler', require('./session-handler.vue').default);

// Document Signing
Vue.component('document-signatures', require('./components/documents/signatures.vue').default);
Vue.component('signature-toggle', require('./components/documents/signature-toggle.vue').default);

// Icons
Vue.component('btn-right-arrow', require('./components/icons/btn-right-arrow.vue').default);
Vue.component('user-icon', require('./components/icons/user.vue').default);

// Disclaimer
Vue.component('disclaimer', require('./components/shared/disclaimer.vue').default);

// Admin
Vue.component('advertiser-details', require('./components/admin/advertisers/advertiser-details.vue').default);
Vue.component('advertiser-selector', require('./components/admin/advertisers/advertiser-selector.vue').default);
Vue.component('advertiser-select', require('./components/admin/advertisers/advertiser-select.vue').default);
Vue.component('product-type', require('./components/admin/advertisers/product-type.vue').default);
Vue.component('product-type-selector', require('./components/admin/advertisers/product-type-selector.vue').default);
Vue.component('advertiser-switcher', require('./components/admin/advertisers/advertiser-switcher.vue').default);

// Navbar
Vue.component('advertiser-navbar', require('./components/navbar/advertiser/advertiser-navbar.vue').default);
Vue.component('admin-navbar', require('./components/navbar/admin/admin-navbar.vue').default);

// Looker
Vue.component('looker-embed', require('./components/looker-embed.vue').default);
Vue.component('looker-embed-plain', require('./components/looker-embed-plain.vue').default);
Vue.component('looker-date-range-picker', require('./components/looker-date-range-picker.vue').default);

// Campaign Dashboard (list campaigns)
Vue.component('campaign-dashboard', require('./components/campaigns/dashboard.vue').default);
Vue.component('campaign-dashboard-list', require('./components/campaigns/dashboard-list.vue').default);
Vue.component('campaign-dashboard-row', require('./components/campaigns/dashboard-row.vue').default);

// Campaign Manager (show campaign)
Vue.component('campaign-manager', require('./components/campaigns/manager/manager.vue').default);
Vue.component('campaign-manager-details', require('./components/campaigns/manager/details.vue').default);
Vue.component('campaign-manager-ad-set-list', require('./components/campaigns/manager/ad-set-list.vue').default);

// Campaign Reporting
Vue.component('campaign-reporting-deposits', require('./components/campaigns/deposits/reporting.vue').default);
Vue.component('campaign-reporting-mortgage', require('./components/campaigns/mortgage/reporting.vue').default);
Vue.component('campaign-reporting-home-equity', require('./components/campaigns/home_equity/reporting.vue').default);
Vue.component('general-reporting', require('./components/general/reporting.vue').default);

// Campaign CRUD
Vue.component('campaign-create', require('./components/campaigns/create.vue').default);
Vue.component('campaign-edit', require('./components/campaigns/edit.vue').default);
Vue.component('campaign-editor', require('./components/campaigns/editor.vue').default);

// AdSet CRUD
Vue.component('campaign-adset-create', require('./components/adsets/create.vue').default);
Vue.component('campaign-adset-edit', require('./components/adsets/edit.vue').default);
Vue.component('campaign-adset-editor', require('./components/adsets/editor.vue').default);

// AdSet Preview
Vue.component('campaign-ad-set-row', require('./components/adsets/ad-set-row.vue').default);
Vue.component('campaign-ad-set-header-row', require('./components/adsets/ad-set-header-row.vue').default);

// Mortgage AdSet Preview
Vue.component('mortgage-campaign-adset-preview', require('./components/adsets/mortgage/preview.vue').default);
Vue.component('mortgage-campaign-adset-preview-creative', require('./components/adsets/mortgage/preview-creative.vue').default);
Vue.component('mortgage-campaign-adset-preview-rate-checks', require('./components/adsets/mortgage/preview-rate-checks.vue').default);
Vue.component('mortgage-campaign-adset-preview-summary', require('./components/adsets/mortgage/preview-summary.vue').default);
Vue.component('mortgage-campaign-adset-preview-summary-row', require('./components/adsets/mortgage/preview-summary-row.vue').default);

// Deposits AdSet Preview
Vue.component('deposits-campaign-adset-preview', require('./components/adsets/deposits/preview.vue').default);
Vue.component('deposits-campaign-adset-preview-rate-checks', require('./components/adsets/deposits/preview-rate-checks.vue').default);
Vue.component('deposits-campaign-adset-preview-summary', require('./components/adsets/deposits/preview-summary.vue').default);
Vue.component('deposits-campaign-adset-preview-summary-row', require('./components/adsets/deposits/preview-summary-row.vue').default);

// Billing Setup
Vue.component('billing-setup', require('./components/billing-setup/setup.vue').default);
Vue.component('billing-manage-cards', require('./components/billing-setup/manage-cards.vue').default);
Vue.component('billing-select-payment-plan', require('./components/billing-setup/select-payment-plan.vue').default);
Vue.component('billing-add-funds', require('./components/billing-setup/add-funds.vue').default);
Vue.component('billing-credit-line', require('./components/billing-setup/credit-line.vue').default);
Vue.component('billing-authorization', require('./components/billing-setup/authorization.vue').default);
Vue.component('billing-payment-history', require('./components/billing-setup/payment-history.vue').default);

// Consumer Reviews
Vue.component('consumer-reviews', require('./components/tools/consumer-reviews/reviews.vue').default);
Vue.component('consumer-review', require('./components/tools/consumer-reviews/review.vue').default);
Vue.component('consumer-review-response-form', require('./components/tools/consumer-reviews/review-response.vue').default);
Vue.component('review-stars', require('./components/tools/consumer-reviews/review-stars.vue').default);
Vue.component('reviews-summary', require('./components/tools/consumer-reviews/reviews-summary.vue').default);
Vue.component('reviews-analytics', require('./components/tools/consumer-reviews/reviews-analytics.vue').default);
Vue.component('pagination', require('./components/tools/consumer-reviews/pagination.vue').default);

// Tools
Vue.component('tools-page', require('./components/tools/tools-page.vue').default);
Vue.component('ad-set-trace', require('./components/tools/ad-set-trace.vue').default);

// Formula
Vue.component('formula-edit-page', require('./components/formula/formula-edit-page.vue').default);
Vue.component('price-check-page', require('./components/formula/price-check-page.vue').default);
Vue.component('formula-lookup-page', require('./components/formula/lookup-page.vue').default);

// Home Equity Rate Management
Vue.component('rate-list', require('./components/home-equity/rates/rate-list.vue').default);
Vue.component('rate-list-history', require('./components/home-equity/rates/rate-list-history.vue').default);

// Number Provisioning
Vue.component('advertisers-provisioning', require('./components/admin/advertisers/provisioning.vue').default);

// User Profile
Vue.component('user-profile', require('./components/profile/profile.vue').default);

Vue.component('advertisers-favorites-section', require('./components/treasury/favorite/advertiser-vertical.vue').default);

// require('./components/admin/advertisers/store.js');

// Security
Vue.directive('role', roleDirective);
Vue.mixin(securityMixin);
Vue.mixin(featureFlagMixin);

var vm = new Vue({
    el: '#vue-app'
});
